import { useContext, useEffect } from 'react';
import { UIContext } from '../contexts';

const useScrollRestore = () => {
	const { originCategorySlug, setOriginCategorySlug } = useContext(UIContext);

	useEffect(() => {
		if (typeof window === 'undefined' || !originCategorySlug)
			return undefined;

		const rafId = requestAnimationFrame(() => {
			const el = document.getElementById(
				`category-${originCategorySlug}`
			);
			if (el) {
				el.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
			setOriginCategorySlug(null);
		});

		return () => cancelAnimationFrame(rafId);
	}, [originCategorySlug, setOriginCategorySlug]);
};

export default useScrollRestore;
